module.exports = __webpack_public_path__ + "static/data_bar_2-71ad69a1fb2a38ff4dd5d105e3b25a83.png";